'use client';

import * as React from 'react';

import { cn } from '../lib/cn';

import { Avatar, AvatarFallback, AvatarImage } from './avatar';

export function initialsFrom(displayName: string | null | undefined, email?: string): string {
  const source = (displayName ?? '').trim();
  if (source.length > 0) {
    const parts = source.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0]?.[0] ?? ''}${parts[1]?.[0] ?? ''}`.toUpperCase();
    }
    return source.slice(0, 2).toUpperCase();
  }
  return (email ?? '?').slice(0, 2).toUpperCase();
}

export interface UserAvatarProps {
  displayName?: string | null;
  email?: string;
  avatarUrl?: string | null;
  className?: string;
  fallbackClassName?: string;
}

export function UserAvatar({
  displayName,
  email,
  avatarUrl,
  className,
  fallbackClassName,
}: UserAvatarProps): React.ReactElement {
  const initials = initialsFrom(displayName, email);
  const label = (displayName ?? '').trim().length > 0 ? (displayName ?? '') : (email ?? '');

  return (
    <Avatar className={cn('size-8', className)}>
      {avatarUrl ? <AvatarImage src={avatarUrl} alt={label} /> : null}
      <AvatarFallback
        className={cn(
          'bg-primary-tint text-primary-strong text-[11px] font-bold',
          fallbackClassName,
        )}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
